import { useEffect, useState } from 'react';
import cx from 'classnames';
import CommonImage from '../CommonImage';
import { useTranslations } from 'next-intl';
import Styles from './index.module.scss';

interface ICheckModal {
  isChecked: boolean;
  onClose: () => void;
}

const CheckInModal = ({
  isChecked,
  onClose
}: ICheckModal) => {
  const [isShow, setIsShow] = useState(false);
  const t = useTranslations();

  return (
    <div className={Styles.root}>
      <div className={Styles.main}>
        <div className={Styles.content}>
          <CommonImage 
            src="https://bbs.djicdn.com/static/image/2023index/sign%20up@3x.png"
            layout={[96, 96]} 
          />
          <div className={cx(Styles.text, {[Styles.checkedText]: isChecked})}>{isChecked ? t("tips_checked") : t("tips_check")}</div>
        </div>
        <button className={Styles.confirm} onClick={onClose}>{t("btn_confirm")}</button>
      </div>
    </div>
  )
}

export default CheckInModal;